/**
 * Convierte una sola imagen File a base64
 * @param {File} file 
 * @returns {Promise<string>} Base64
 */
export const unaABase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

/**
 * Convierte un array de imágenes File a base64
 * @param {File[]} files 
 * @returns {Promise<string[]>} Array de base64
 */
export const muchasABase64 = async (files) => {
  const resultados = [];
  for (const file of files) {
    const base64 = await unaABase64(file);
    resultados.push(base64);
  }
  return resultados;
};